import { AxiosResponse } from "axios";
import instance from "../common/http.common";
import {
  AddUser,
  CheckUser,
  DeleteUser,
  GetUsers,
  UpdateUserAsAdministrator,
  UpdateUserAsHR,
} from "../common/ApiEndPoints";

const _rootUrl: string = process.env.REACT_APP_API_ROOT_URL ?? "";
const _baseUrl: string = `${_rootUrl}/User`;

const GetAllUsers = async (): Promise<AxiosResponse<any>> => {
  return await instance.get(_baseUrl + GetUsers);
};

const AddNewUser = async (userData: any): Promise<AxiosResponse<any>> => {
  return await instance.post(_baseUrl + AddUser, userData);
};

const CancelUser = async (id: any): Promise<AxiosResponse<any>> => {
  return await instance.delete(`${_baseUrl + DeleteUser}/?userID=${id}`);
};

const UpdateAdminRole = async (id: any, isAdmin: boolean): Promise<AxiosResponse<any>> => {
  return await instance.post(
    `${_baseUrl + UpdateUserAsAdministrator}/?userID=${id}&isAdmin=${isAdmin}`
  );
};

const UpdateHRRole = async (id: any, isHR: boolean): Promise<AxiosResponse<any>> => {
  return await instance.post(
    `${_baseUrl + UpdateUserAsHR}/?userID=${id}&isHR=${isHR}`
  );
};

const CheckIsUserExist = async (email: any): Promise<AxiosResponse<any>> => {
  return await instance.get(`${_baseUrl + CheckUser}/?email=${email}`);
};

const GetPendingApprovals = async (email: any): Promise<AxiosResponse<any>> => {
  return await instance.get(`${_baseUrl}/GetPendingApprovals/?email=${email}`);
};

export const UserDetialsService = {
  GetAllUsers,
  CancelUser,
  CheckIsUserExist,
  GetPendingApprovals,
  AddNewUser,
  UpdateAdminRole,
  UpdateHRRole,
};
